export default __webpack_public_path__ + "static/media/pillars.98ea07d4.png";